export const getFacebookCookies = () => {
    if (typeof window !== 'undefined') {
        // Get fbp cookie
        const fbpCookie = document.cookie
            .split('; ')
            .find(row => row.startsWith('_fbp='))
            ?.split('=')[1]

        // Get fbc cookie
        const fbcCookie = document.cookie
            .split('; ')
            .find(row => row.startsWith('_fbc='))
            ?.split('=')[1]

        return {
            fbp: fbpCookie || null,
            fbc: fbcCookie || null,
        }
    }
    return { fbp: null, fbc: null }
}
